<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        :style="{ backgroundColor }"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M22.4369 42.3109V38.0543C20.4239 37.7022 18.7902 36.9301 17.5358 35.738C16.2815 34.546 15.3971 33.034 14.8826 31.2021L18.3043 29.8543C18.8333 31.5297 19.6312 32.7402 20.6978 33.4858C21.7645 34.2315 23.0007 34.6043 24.4065 34.6043C25.95 34.6043 27.196 34.2373 28.1445 33.5032C29.0931 32.7692 29.5674 31.7681 29.5674 30.5C29.5674 29.1275 29.1043 28.046 28.1782 27.2554C27.2521 26.4648 25.5319 25.6717 23.0174 24.8761C20.6551 24.1471 18.8728 23.1163 17.6706 21.7837C16.4685 20.4511 15.8674 18.8065 15.8674 16.85C15.8674 15.0732 16.4355 13.5351 17.5717 12.2358C18.7079 10.9366 20.3297 10.1565 22.4369 9.89564V5.68909H25.7478V9.89564C27.2855 10.1377 28.6243 10.6859 29.7641 11.5402C30.904 12.3946 31.7667 13.521 32.3522 14.9195L28.9869 16.3174C28.5203 15.2884 27.8953 14.5228 27.1119 14.0206C26.3286 13.5185 25.3225 13.2674 24.0935 13.2674C22.6544 13.2674 21.5319 13.575 20.7261 14.1902C19.9203 14.8054 19.5174 15.6565 19.5174 16.7435C19.5174 17.8971 19.9609 18.8467 20.8478 19.5924C21.7348 20.338 23.5659 21.1369 26.3413 21.9891C28.6457 22.7268 30.3678 23.7728 31.5076 25.1271C32.6475 26.4815 33.2174 28.2058 33.2174 30.3C33.2174 32.4565 32.5866 34.2 31.325 35.5304C30.0634 36.8609 28.2043 37.7188 25.7478 38.1043V42.3109H22.4369Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
